<template>
    <b-container>
        <div>
            <h3>Reports</h3>
        </div>



        <div class="ml-2 w-100 px-4 px-md-">
            <b-row>

                <b-col cols=12 md=auto class="mt-3">
                    <div class="d-flex flex-row align-items-center">
                        <label class="filter-label" :for="'fromDate'">From</label>
                        <div class="ml-2 w-100 px-4 px-md-1">
                            <b-form-datepicker :date-format-options="dateFormatOption" :min="minFromDate" :max="maxFromDate"
                                class="filter-date-input-white notranslate" :id="'fromDate'" type="date" v-model="fromDate">
                            </b-form-datepicker>
                        </div>
                    </div>
                </b-col>

                <b-col cols=12 md=auto class="mt-3 date-picker-div">
                    <div class="d-flex flex-row align-items-center">
                        <label class="filter-label" :for="'toDate'">To</label>
                        <div class="ml-2 w-100 px-4 px-md-1">
                            <b-form-datepicker :date-format-options="dateFormatOption" :min="minToDate" :max="maxToDate"
                                class="filter-date-input-white notranslate" :id="'toDate'" type="date" v-model="toDate">
                            </b-form-datepicker>
                        </div>
                    </div>
                </b-col>

                <b-col md=auto class="date-div">
                    <b-button class="date-button" variant="primary" @click="dateFilter">Apply</b-button>
                </b-col>

                <b-col md=auto class="date-div">
                    <b-button class="clear-button" variant="secondary" @click="clearDateFilter">Clear</b-button>
                </b-col>

            </b-row>
            <div class="card px-4">
                <div class="reporting-dashboard-charts mt-2 mt-md-5" v-if="showGraph && !isLoading">

                    <div>
                        <h3 class="graph-heading">Top 5 Clients</h3>
                    </div>

                    <div class="row">

                        <b-col>
                            <div class="col-md-12 mb-0 line-graph-div">
                                <div class="h-auto">
                                    <div v-if="userSignupsLine && !isLoading" class="card-body">
                                        <line-chart :chart-data="userSignupsLine" :options="optionsLine" />
                                    </div>
                                </div>
                            </div>
                        </b-col>

                        <b-col>
                            <div class="col-md-12 mb-0 bar-graph-div">
                                <div class="h-auto">
                                    <div v-if="userSignupsBar && !isLoading" class="card-body">
                                        <bar-chart :chart-data="userSignupsBar" :options="optionsBar" />
                                    </div>
                                </div>
                            </div>
                        </b-col>

                    </div>

                </div>

                <b-row>
                    <b-col cols=6 class="clients-search-col">
                        <div class="d-flex flex-row align-items-center">
                            <div class="ml-2 w-100 px-4 px-md-1">
                                <multiselect v-model="selectedClients" :options="allClientsList" track-by="id" label="name"
                                    placeholder="Select clients" title="Select the clients" :multiple="true"
                                    :close-on-select="false" :clear-on-select="true" :allow-empty="true">
                                </multiselect>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols=1 class="clients-search-col">
                        <b-button class="client-button" variant="primary" @click="clientFilter">Search</b-button>
                    </b-col>

                    <b-col cols=1 class="clients-search-col">
                        <b-button class="client-button" variant="secondary" @click="clearClientFilter">Clear</b-button>
                    </b-col>

                    <b-col cols=3 class="download-button-col">
                        <b-dropdown text="Download CSV" variant="info">
                            <b-dropdown-item-button @click="downloadCSV(false)">Download this page</b-dropdown-item-button>
                            <b-dropdown-item-button @click="downloadCSV(true)">Download all rows</b-dropdown-item-button>
                        </b-dropdown>
                    </b-col>
                </b-row>

                <!-- All Clients Table -->
                <div class=" border-0">
                    <div class="card-body px-0 rounded overflow-auto">
                        <div class="b2b-table">
                            <b-table class="reporting-table" hover :items="rows" :fields="fields" :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc" :busy="isLoading" @row-clicked="redirectClient">
                            </b-table>
                        </div>

                        <!-- Pagination -->
                        <div class="pagination">
                            <Multiselect :options="pageSizeArray" v-model="pageSize" class="pageSizeMS" />
                            <b-pagination v-model="page" :total-rows="totalRecords" :per-page="pageSize" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
import Multiselect from 'vue-multiselect';
import LineChart from "@/module_user/components/LineChart";
import BarChart from "@/module_user/components/BarChart";

import API from "../api.js"
export default {
    name: "ReportingDashboard",
    data() {
        return {
            minFromDate: undefined,
            maxFromDate: undefined,
            minToDate: undefined,
            maxToDate: undefined,
            fromDate: '',
            toDate: '',
            dateFormatOption: { year: 'numeric', month: 'short', day: '2-digit' },
            sortBy: '',
            sortDesc: false,
            rows: [],
            fields: [
                { key: 'id', sortable: true },
                { key: 'name', sortable: true },
                { key: 'type', sortable: false },
                { key: 'users', sortable: true },
                { key: 'workouts_clicked', sortable: true },
                { key: 'workouts_completed', sortable: true },
                { key: 'workout_duration', sortable: true }
            ],
            selectedClients: [],
            selectedClientsID: '',
            allClientsList: [],
            isLoading: false,
            showGraph: true,
            optionsLine: {
                legend: {
                    display: true,
                    position: 'bottom'
                },
                title: {
                    display: true,
                    text: "Signups by Client Users on a Daily Basis"
                },
            },
            optionsBar: {
                legend: false,
                title: {
                    display: true,
                    text: "Total Signups by Client Users"
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#white',
                            showLabelBackdrop: false
                        },
                    }],
                },
            },
            userSignupsLine: null,
            userSignupsBar: null,
            page: 1,
            pageSize: 20,
            totalRecords: 0,
            datasetsLine: [],
            datasetsBar: [],
            colors: ['#FF6699', '#66CCCC', '#FF9933', '#3399CC', '#9966FF'],
            pageSizeArray: [10, 20, 50, 100],
            totalRecords: 0,
        }
    },
    watch: {
        fromDate: function (val) {
            ''
            this.minToDate = new Date(val);
        },
        toDate: function (val) {
            this.maxFromDate = new Date(val);
        },
        page() {
            this.allClients();
        },
        pageSize() {
            if (this.pageSize !== 0) {
                this.allClients();
            }
        },
        sortBy() {
            this.allClients();
        },
        sortDesc() {
            this.allClients();
        },
    },
    methods: {

        redirectClient(item) {
            const searchParams = new URLSearchParams(window.location.search)
            searchParams.set("startDate", this.fromDate)
            searchParams.set("endDate", this.toDate)
            const newRelativePathQuery = window.location.pathname + `/${item.name}/${item.id}` + "?" + searchParams.toString()
            this.$router.replace({ path: newRelativePathQuery });
        },
        async clearDateFilter() {
            this.fromDate = '';
            this.toDate = '';
        },

        dateFilter() {
            this.isLoading = true;
            this.getTopClients()
            this.allClients()
        },

        clientFilter() {
            this.selectedClientsID = this.selectedClients.map((client) => client.id).toString()
            this.allClients()
        },

        clearClientFilter() {
            this.selectedClients = [];
            this.selectedClientsID = [];
            this.allClients()
        },

        async downloadCSV(downloadAll) {
        
            const downloadCSVParam = {
                page: this.page,
                perPage: downloadAll ? this.totalRecords : this.pageSize,
                startDate: this.fromDate,
                endDate: this.toDate,
                resType: 'CSV',
            }

            try {
                let data = await API.allClients(downloadCSVParam)

                const blob = new Blob([data], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.setAttribute('href', url)
                a.setAttribute('download', 'AllClients.csv');
                a.click()
            }
            catch (error) {
                console.log("There is an error in Downloading CSV", error);
            }
        },

        getChartData(chartLabel, labels, dataPoints, backgroundColor) {
            return {
                labels: labels,
                datasets: [
                    {
                        label: chartLabel,
                        data: dataPoints,
                        backgroundColor: backgroundColor,
                        tension: 0.4
                    },
                ]
            }
        },

        workoutDurationFormat(total) {
            let minutes = 0;
            let hours = 0;
            let seconds = 0;
            minutes = Math.trunc(total / 60);
            seconds = total % 60;
            hours = Math.trunc(minutes / 60);
            minutes = Math.trunc(minutes % 60);

            if (hours > 0)
                return hours + "h " + minutes + "m "

            else if (minutes > 0)
                return minutes + "m "

            else if (minutes <= 0)
                return seconds + "s "
        },

        async getTopClients() {
            const topClientsParam = {
                startDate: this.fromDate,
                endDate: this.toDate
            }
            try {
                let res = await API.getTopClients(topClientsParam)
                this.fromDate = res.startDate;
                this.toDate = res.endDate;

                // Line Chart
                res.data.userSignUp.dataPoints.forEach((item, index) => {
                    this.datasetsLine.push({
                        label: item.clientName,
                        data: item.data,
                        borderColor: this.colors[index],
                        backgroundColor: 'rgba(255, 255, 255, 0.0)'
                    });
                });

                this.userSignupsLine = {
                    labels: res.data.userSignUp.label,
                    datasets: this.datasetsLine,
                }

                // Bar Chart
                this.userSignupsBar = this.getChartData(
                    res.data.userSignUp.label,
                    res.data.userSignUpTotal.label,
                    res.data.userSignUpTotal.dataPoints,
                    ['#FF6699', '#66CCCC', '#FF9933', '#3399CC', '#9966FF'],
                )
                this.isLoading = false;
            }
            catch (error) {
                console.log("There is an error in topClients", error);
            }
        },

        async clientsList() {
            try {
                let res = await API.corporateClientList()

                res.data.forEach((item) => {
                    this.allClientsList.push({
                        id: item.id,
                        name: item.name
                    })
                })

            }
            catch (error) {
                console.log("There is an error in clientsList", error);
            }
        },

        async allClients() {
            const allClientsParam = {
                page: this.page,
                perPage: this.pageSize,
                startDate: this.fromDate,
                endDate: this.toDate,
                selectedClients: this.selectedClientsID,
                sortBy: this.sortBy,
                sortDirection: this.sortDesc ? 'DESC' : 'ASC'
            }

            try {
                let res = await API.allClients(allClientsParam)
                this.fromDate = res.startDate;
                this.toDate = res.endDate;
                this.rows = []
                res.data.rows.forEach((item) => {


                    this.rows.push({
                        id: item.id,
                        name: item.name,
                        type: item.clientType,
                        users: item.totalUsers,
                        workouts_clicked: item.totalWorkoutsClicked,
                        workouts_completed: item.totalWorkoutsCompleted,
                        workout_duration: this.workoutDurationFormat(item.totalWorkoutDurationSec),
                    });
                });
                this.totalRecords = res.data.total
            }
            catch (error) {
                console.log("There is an error in allClients", error);
            }
        },
    },

    mounted() {
        this.allClients();
        this.getTopClients();
        this.clientsList();
    },
    components: {
        Multiselect,
        LineChart,
        BarChart
    },
}
</script>

<style lang="scss" scoped>
::v-deep .multiselect__tags {
    min-height: 0;
    padding: 0;
    background: #FFFFFF !important;
    border: 2px solid #73BC44;
    border-radius: 5px !important;
    height: 34px !important;
    min-width: 135px !important;
    display: flex;
    align-items: center;
}

::v-deep .multiselect__placeholder {
    margin: 5px 0 5px 10px;
    color: #969B92;
    font-weight: 500;
}

::v-deep .multiselect__single {
    margin-bottom: 0px !important;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #141513 !important;
}

::v-deep .multiselect__select:before {
    color: #73BC44 !important;
    border-color: #73BC44 transparent transparent;
}

::v-deep .multiselect__tags-wrap {
    display: flex !important;
    align-items: center !important;
}

::v-deep .multiselect__tag {
    margin-bottom: 0;
}

h3 {
    font-size: 25px;
    font-weight: bold;
    margin-left: 20px;
    color: white;
}



/* Card Body */
.card {
    border: none;
    background-color: #323232;
    margin-top: 20px;

    .card-body {
        position: relative;
        padding-bottom: 20px;
        margin-bottom: 30px;
    }
}

/* Date Picker and Buttons */

.filter-label {
    top: 50%;
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
    color: white;
}

.date-picker-div {
    padding-left: 0px;
    padding-right: 10px;
}

.date-div {
    padding-left: 10px;
}

.date-button {
    margin-top: 15px;
    height: 35px;
}

.clear-button {
    margin-top: 15px;
    height: 35px;
}

// Client Search Bar

.clients-search-col {
    width: 50%;
    margin-bottom: 10px;
    margin-right: 10px;
    padding-left: 0px;
}

.client-button {
    margin: 0px, 10px, 30px, 100px;
    height: 35px;
}

// Download Button
.download-button-col {
    text-align: right;
    margin-left: 40px;
}

// Download Modal
.download-modal-button {
    margin: 15px;
}

//  Graph Section 
.line-graph-div {
    padding-left: 10px;
    padding-right: 0px;
}

.bar-graph-div {
    padding-left: 0px;
}

.graph-heading {
    margin-left: 30px;
    margin-bottom: 30px;
}

// Reporting Table
.reporting-table {
    cursor: pointer;
}


// Pagination
.pageSizeMS {
    width: 200px;
    margin-left: 10px;
    margin-right: 25px;
}
</style>